<template>
  <layout :title="post.title">
    <JsonLd :entries="jsonLdEntries" />
    <div class="max-w-4xl px-5 mx-auto mt-10 lg:px-0">
      <inertia-link
        :href="
          post.category_id == 1
            ? $route('resources.blog')
            : post.category_id == 2
            ? $route('resources.press')
            : $route('resources.projects')
        "
        class="inline-flex items-center mb-2 font-mono text-sm font-bold cursor-pointer text-primary-color"
      >
        <svg
          class="w-4 h-4 mr-2"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M10 19l-7-7m0 0l7-7m-7 7h18"
          ></path>
        </svg>
        back to the
        {{
          post.category_id == 1
            ? "blog"
            : post.category_id == 2
            ? "press"
            : "projects"
        }}
      </inertia-link>
    </div>
    <article
      :id="'post-' + post.id"
      class="max-w-4xl px-5 mx-auto prose prose-xl lg:prose-2xl lg:px-0 pb-12"
    >
      <meta property="name" :content="post.title" />
      <meta property="author" typeof="Person" content="admin" />
      <meta property="dateModified" :content="post.updated_at | formatDate" />
      <meta
        class="uk-margin-remove-adjacent"
        property="datePublished"
        :content="post.created_at | formatDate"
      />

      <div class="max-w-4xl mx-auto mt-6">
        <h1 class="flex flex-col leading-none">
          <span class="break-words">{{ post.title }}</span>
          <span class="mt-10 text-base font-normal" v-if="post.category_id != 3"
            >Written on
            <time :datetime="post.created_at | formatDate">{{
              post.created_at | formatDate
            }}</time>
          </span>
        </h1>
      </div>

      <div class="relative">
        <img
          v-if="post.image"
          class="w-full h-auto rounded-lg"
          :src="aws_image_path + post.image"
          :alt="post.title"
          :srcset="aws_image_path + post.image"
        />
      </div>

      <div class="max-w-4xl mx-auto" v-html="post.body">{{ post.body }}</div>

      <TagsSection
        :tags="post.tags"
        :route="
          post.category_id == 1
            ? $route('resources.blog')
            : $route('resources.press')
        "
      />
      <newsletterForm :errors="errors" />
      <NewsletterPopup :errors="errors" />
    </article>
  </layout>
</template>

<script>
const layout = () =>
  import(/* webpackChunkName: "layout" */ "../Components/Layout/layout.vue");

const newsletterForm = () =>
  import(
    /* webpackChunkName: "newsletterForm" */ "../Components/Layout/newsletterForm.vue"
  );

import TagsSection from "../Components/Layout/Resources/TagsSection.vue";
import NewsletterPopup from "../Components/Layout/NewsletterPopup.vue";
import JsonLd from "../Components/SEO/JsonLd.vue";
import { buildArticleSchema, resolveMediaUrl } from "../utils/structuredData";

export default {
  props: {
    errors: Object,
  },
  components: { layout, newsletterForm, TagsSection, NewsletterPopup, JsonLd },
  data() {
    return {
      post: this.$page.props.post,
      aws_image_path: process.env.MIX_IMAGES_PATH,
    };
  },
  computed: {
    jsonLdEntries() {
      const articleType =
        this.post.category_id === 1
          ? "BlogPosting"
          : this.post.category_id === 2
          ? "NewsArticle"
          : "Article";
      const image = resolveMediaUrl(this.post.image, this.aws_image_path);
      const datePublished = this.post.release_date || this.post.created_at;

      return [
        buildArticleSchema({
          type: articleType,
          title: this.post.title,
          description: this.post.meta_description || this.post.body,
          url: window.location.pathname,
          image,
          datePublished,
          dateModified: this.post.updated_at,
        }),
      ];
    },
  },
};
</script>